// Per-publisher Pixie opt-in. Missing/undefined is off (fail-closed).

import type { ExperiencePayload } from "@/types/experience";

export function isAskEnabled(
  experienceData: ExperiencePayload | null | undefined,
): boolean {
  return experienceData != null && experienceData.askEnabled === true;
}

// Voice is its own flag on the experience payload. Missing is off.
export function isVoiceEnabled(
  experienceData: ExperiencePayload | null | undefined,
): boolean {
  return experienceData != null && experienceData.voiceEnabled === true;
}
